import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { initKeycloak } from "./lib/auth-service";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "rc-slider/assets/index.css";
import "./index.css";

const container = document.querySelector("#root") as Element;
const root = createRoot(container);

initKeycloak().then(() => {
  const THIRTY_MINUTES = 30 * 60 * 1000; // 1800000ms

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: THIRTY_MINUTES, // 30 минутад шинэ гэж тооцно
        gcTime: THIRTY_MINUTES, // 30 минутын дараа cache устана
        refetchOnWindowFocus: false, // (optional) цонх руу буцахад дахин fetch хийхгүй
      },
    },
  });
  root.render(
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
});
